<script lang="ts">
  import clsx from 'clsx';
  import { Image } from '@athena-lib/Image';
  import { urlsAreEqual } from '@athena-lib/url';
  import { User } from '@athena-lib/Icons';
  import { Link } from '@athena-lib/Link';
  import ShoppingCartWithCount from '@athena-lib/ShoppingCartWithCount/ShoppingCartWithCount.svelte';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { DrawerButton, SearchButton } from '..';
  import type { MenuItem, MenuProps } from './types';
  import { splitItems } from './utils';

  const {
    items,
    stickerAppLogoUrl,
    currentUrl,
    class: className,
    openDrawer,
    openSearch,
    itemsInCart,
    onCheckoutClick,
    onAccountClick,
  }: MenuProps = $props();

  const { leftSideMenu, rightSideMenu } = $derived(splitItems(items));
  const translations = getCommonTranslations();
</script>

{#snippet menuItems(menu: { items: MenuItem[]; isRight?: boolean })}
  <ul class="flex w-full items-center justify-around">
    {#if !menu.isRight}
      <li class="flex items-center gap-6 text-st-white">
        <DrawerButton
          sizeClass="h-8 w-8"
          label={translations.toggleNavigation}
          onClick={openDrawer}
        />
        <SearchButton label={translations.searchToggle} onClick={openSearch} />
      </li>
    {/if}
    {#each menu.items as item}
      <li>
        <a
          class={clsx(
            'py-1 text-base font-extrabold tracking-wider text-st-white hover:border-b-2 hover:border-st-yellow xl:text-lg',
            urlsAreEqual(currentUrl?.pathname, item.link?.href ?? '') &&
              'border-b-2 border-st-yellow',
          )}
          href={item.link?.href}
        >
          {item.text}
        </a>
      </li>
    {/each}
    {#if menu.isRight}
      <li class="flex items-center gap-6 text-st-white">
        <button type="button" onclick={onAccountClick} aria-label={translations.account}>
          <User sizeClass="h-8 w-8" />
        </button>
        <ShoppingCartWithCount
          sizeClass="h-8 w-8"
          countPromise={itemsInCart}
          onClick={onCheckoutClick}
        ></ShoppingCartWithCount>
      </li>
    {/if}
  </ul>
{/snippet}

<nav
  aria-label={translations.mainMenu}
  class={clsx('flex w-full items-center justify-around', className)}
>
  {@render menuItems({ items: leftSideMenu })}
  <Link href="/" class="px-8">
    <Image src={stickerAppLogoUrl} alt="Sticker App" />
  </Link>
  {@render menuItems({ items: rightSideMenu, isRight: true })}
</nav>
